<div [id]="'promptuary-compliance-section-'+type" class="zk-flex zk-gap-2 zk-items-center">
	<span class="freud-icon freud-icon-shield-check"></span>
	<p id="compliance-description-text" freud-typography fontType="smallRegular1-5">
		{{ 'PROMPTUARY.COMPLIANCE.DESCRIPTION' | translate }}
		<span (click)="openModal()" class="learn-more-text">
			{{ 'PROMPTUARY.COMPLIANCE.LEARN_MORE' | translate }}
		</span>
	</p>
</div>